export default [
    {
        card: "invoice_third",
        component: "stat-default-card",
        title: Loc.g("Facturation"),
        labels: {
            due: {
                title: () => {
                    return window.i18n.__('A régler')
                },
                count: Loc.g("Factures"),
                amount: Loc.g("Montant")
            },
            late: {
                title: () => {
                    return window.i18n.__('En retard')
                },
                count: Loc.g("Factures"),
                amount: Loc.g("Montant")
            }
        }
    },
    {
        card: "estimate_third",
        component: "stat-default-card",
        title: Loc.g("Prospection"),
        labels: {
            accepted: {
                title: () => {
                    return window.i18n.__('Devis en attente de facturation')
                },
                count: Loc.g("Devis"),
                amount: Loc.g("Montant")
            },
            expired: {
                title: () => {
                    return window.i18n.__('Devis expirés')
                },
                count: Loc.g("Devis"),
                amount: Loc.g("Montant")
            }
        }
    },
    {
        card: "turnover_third",
        component: "stat-secondary-card",
        title: Loc.g("Chiffre d'affaires"),
        labels: {
            invoices: {
                title: () => {
                    return window.i18n.__('Factures')
                },
            },
            creditnotes: {
                title: () => {
                    return window.i18n.__('Avoirs')
                },
            }
        }
    },
    {
        card: "top_selling_items_third",
        component: "stat-list-card",
        title: window.i18n.__("TOP %(rank)s vente produits / services", { "rank": 10}),
    },
    {
        card: "sales_margin_third",
        component: "stat-default-card",
        title: Loc.g("Marge"),
        labels: {
            margin: { 
                title: (nb) => {
                    return window.i18n.n__('%s facture', '%s factures', nb, nb)
                },
                margin: Loc.g("Taux"),
                amount: Loc.g("Montant"),
                nb: Loc.g("Nombre")
            },
        }
    },
]